import { Amplify } from 'aws-amplify';
import ReactDOM from 'react-dom';
// import Swagger from './Swagger/Swagger';
import '@aws-amplify/ui-react/styles.css';
import App from "./App";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: `${ process.env.REACT_APP_USER_POOL_ID }`,
      userPoolClientId: `${ process.env.REACT_APP_APP_CLIENT_ID }`,
      identityPoolId: `${ process.env.REACT_APP_IDENTITY_POOL_ID }`
    }
  }
});

ReactDOM.render(<App />, document.getElementById('root'));